// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-4d8b6834]{font-size:26px!important;font-weight:700}.text-content[data-v-4d8b6834]{font-size:20px}", ""]);
// Exports
module.exports = exports;
